import { Tooltip } from '@mui/material';
import RowActions from '@components/row-actions/row-actions.tsx';
import { ProductCategoriesModel } from '@models/product-categories.model.ts';
import { SelectOption } from '@models/global.model.ts';
import AppImage from '@components/app-image/app-image.tsx';

export const productCategoriesColumns = (
  handleEdit: (row: ProductCategoriesModel) => void,
  handleDelete: (row: ProductCategoriesModel) => void,
  language: string,
  departmentUnit: SelectOption[]
) => [
  {
    id: 'image',
    label: 'column_label_image',
    field: 'image',
    render: (value: any) => (
      <div
        className={`h-13 w-13 rounded-md border border-(--gray-7) overflow-hidden cursor-pointer`}
      >
        <AppImage imgClassName="!h-full" filePath={value ?? undefined} />
      </div>
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  },
  {
    id: 'name',
    label: 'column_label_name',
    field: 'name',
    render: (value: any) => (
      <Tooltip title={value?.[language] || 'N/A'} followCursor>
        <span>{value?.[language] || 'N/A'} </span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: true
  },
  {
    id: 'description',
    label: 'column_label_description',
    field: 'description',
    render: (value: any) => (
      <Tooltip title={value?.[language] || 'N/A'} followCursor>
        <span>{value?.[language] || 'N/A'} </span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false
  },
  {
    id: 'departmentUnit.name',
    label: 'column_label_department_unit',
    field: 'departmentUnit',
    render: (value: any) => (
      <Tooltip title={value?.name || 'N/A'} followCursor>
        <span>{value?.name || 'N/A'} </span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: false,
    showFilter: true,
    filterData: departmentUnit
  },
  {
    id: 'Action',
    label: 'column_label_actions',
    field: 'actions',
    width: 110,
    render: (value: any, row: any) => (
      <RowActions<ProductCategoriesModel>
        row={row}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  }
];
